export const MCP_TOOLS_SETTINGS_LS_KEY = 'mcp_tools_settings_v1';
//# sourceMappingURL=consts.js.map